// extracted by mini-css-extract-plugin
module.exports = {"root":"j_M","profileCard":"j_Z","profileImageWrapper":"j_0","profileImage":"j_1","badges":"j_2","bio":"j_3"};